import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      label: '微信编码',
      field: 'unionid',
      type: 'input',
      placeholder: '请输入微信编码'
    },
    {
      label: '客户昵称',
      field: 'nickName',
      type: 'input',
      placeholder: '请输入客户昵称'
    },
    {
      label: '工作微信号',
      field: 'employeeUserId',
      type: 'input',
      placeholder: '请输入工作微信号'
    },
    {
      label: '对应手机号',
      field: 'phoneNumber',
      type: 'input',
      placeholder: '请输入对应手机号'
    },
    {
      label: '所属部门',
      type: 'select',
      field: 'department',
      placeholder: '请选择所属部门',
      options: [
        { title:'一组', value: '一组' },
        { title:'二组', value: '二组' },
        { title:'三组', value: '三组' },
        { title:'四组', value: '四组' },
        { title:'五组', value: '五组' },
        { title:'六组', value: '六组' },
        { title:'七组', value: '七组' },
        { title:'八组', value: '八组' },
        { title:'九组', value: '九组' },
        { title:'九（一）组', value: '九（一）组'},
        { title:'九（二）组', value: '九（二）组' },
        { title:'十组', value: '十组' },
        { title:'十一组', value: '十一组' },
        { title:'十二组', value: '十二组' },
        { title:'师徒组', value: '师徒组' }
      ]
    },
    {
      label: '同行或成交',
      type: 'select',
      field: 'peerStatus',
      placeholder: '请选择同行或成交',
      options: [
        { title: '被标同行', value: 1 },
        { title: '已成交', value: 2 },
        { title: '炸群', value: 3 },
        { title: '违反信用规定', value: 4 },
        { title: '退费客户', value: 5 },
        { title: '高风险客户', value: 6 },
        { title: '分公司', value: 7 },
        { title: '非精准禁开发', value: 8 }
      ]
    },
    {
      label: '是否重复',
      type: 'select',
      field: 'exist',
      placeholder: '请选择是否重复',
      options: [
        { title: '否', value: 0 },
        { title: '是', value: 1 }
      ]
    },
    {
      label: '企业主体',
      type: 'select',
      field: 'mainBody',
      placeholder: '请选择企业主体',
      options: [
      ]
    },
    {
      label: '客户微信号',
      field: 'customCode',
      type: 'input',
      placeholder: '请输入客户微信号'
    },
    {
      field: 'inputTime',
      type: 'datepicker',
      label: '录入时间段',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD'
      }
    },
    {
      label: '开单渠道',
      type: 'select',
      field: 'channel',
      placeholder: '请选择开单渠道',
      options: [
        { title:'新闻大图/视频扫码', value: '新闻大图/视频扫码' },
        { title:'新闻大图/视频通投', value: '新闻大图/视频通投' },
        { title:'新闻小图/三图扫码', value: '新闻小图/三图扫码' },
        { title:'新闻小图/三图通投', value: '新闻小图/三图通投' },
        { title:'QQ大图/视频', value: 'QQ大图/视频' },
        { title:'QQ小图/三投', value: 'QQ小图/三投' },
        { title:'公众号-支付', value: '公众号-支付' },
        { title:'优量汇', value: '优量汇' },
        { title:'QQ购物', value: 'QQ购物' },
        { title:'搜索直达', value: '搜索直达'},
        { title:'新闻PC端', value: '新闻PC端' },
        { title:'百度信息流', value: '百度信息流' },
        { title:'抖音', value: '抖音' },
        { title:'今日头条', value: '今日头条' },
        { title:'朋友圈', value: '朋友圈' },
        { title:'广点通-朋友圈', value: '广点通-朋友圈' },
        { title:'公众号MP', value: '公众号MP' },
        { title:'新兵营-电话', value: '新兵营-电话' },
        { title:'电话组-诊股', value: '电话组-诊股' },
        { title:'电话组-课程', value: '电话组-课程' },
        { title:'自媒体', value: '自媒体' }
      ]
    }
  ]
}
